/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListByValueRequest = {
  properties: {
    contractCompetencyId: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
